import React from 'react';
import { Link, Popover, List, ListItem, ListItemText } from '@mui/material';
import { WorkLinksOptions } from '../enums';

export function WorkLinks(): JSX.Element {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Link
        underline='none'
        component='a'
        onClick={(event: React.MouseEvent<HTMLAnchorElement>) => handleClick(event)}
      >
        Work Links
      </Link>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        <List>
          {[...WorkLinksOptions]
            .sort((a, b) => a.title.localeCompare(b.title, undefined, { sensitivity: 'base' }))
            .map(({ title, url }) => (
              <ListItem
                key={title}
                component='a'
                href={url}
                target='_blank'
                rel='noopener noreferrer'
                sx={{ textDecoration: 'none', color: 'inherit' }}
              >
                <ListItemText primary={title} />
              </ListItem>
            ))}
        </List>
      </Popover>
    </>
  );
}
